import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { combineLatest, Observable, distinctUntilChanged, filter, map } from 'rxjs';

import { LanguageService } from '@fcom/ui-translate';
import { compareAsJson } from '@fcom/core/utils';

import { CampaignBannerService } from '../../../services/campaign-banner/campaign-banner.service';
import { ElementTypes } from '../../../interfaces';

interface CampaignBanner {
  text: string;
  link: { url: string };
  test?: {
    text: string;
    link: { url: string };
  };
  enableBlackTeaser?: boolean;
}

@Component({
  selector: 'fin-campaign-banner',
  templateUrl: './campaign-banner.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CampaignBannerComponent implements OnInit {
  private languageService = inject(LanguageService);
  private route = inject(ActivatedRoute);
  private campaignBannerService = inject(CampaignBannerService);

  readonly ElementTypes = ElementTypes;
  visibility$: Observable<boolean>;
  campaignLink$: Observable<CampaignBanner>;

  ngOnInit(): void {
    this.visibility$ = this.campaignBannerService.visibility$.pipe(distinctUntilChanged());
    this.campaignLink$ = combineLatest([
      this.languageService.translate<CampaignBanner>('campaignBanner'),
      this.route.queryParams,
    ]).pipe(
      distinctUntilChanged(compareAsJson),
      filter(([translations]) => !!(translations?.link?.url && translations?.text)),
      filter(([, queryParams]) => !(queryParams.utm_campaign && queryParams.utm_source)),
      map(([translations]) => translations),
      distinctUntilChanged()
    );
  }
}
